"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectButton = exports.OnlyTextButton = exports.ChevronButton = exports.ChevronButtonContainer = exports.ButtonContainer = exports.BigArrowLeft = exports.ArrowLeft = exports.ChevronRight = exports.SubmitButton = exports.IconButton = exports.LinkAsButton = exports.SmallButton = exports.ButtonLink = exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("../../assets/svg-components");
const Link_1 = require("../Link");
const Types_1 = require("Types");
exports.StyledButton = styled_components_1.default.button `
  font-weight: ${props => props.theme.typography.weight.medium};
  font-size: ${props => props.theme.typography.size.s3}px;
  line-height: ${props => props.theme.typography.lineHeight.s5}px;
  font-style: normal;

  transition: ${props => props.theme.animations.primary};
  transition-property: color, background;
  border-radius: ${props => props.theme.attributes.borderRadius.xs}px;
  padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.s5}px;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border: none;
  color: ${props => (props.disabled ? props.theme.palette.UI_DISABLED_DETAIL : props.theme.palette.BW_100)};
  stroke: ${props => (props.disabled ? props.theme.palette.UI_DISABLED_DETAIL : props.theme.palette.BW_100)};
  background: ${props => (props.disabled ? props.theme.palette.UI_DISABLED_BACKGROUND : props.theme.palette.BLUE_100)};
  outline-offset: ${props => props.theme.spacing.xs}px;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    &:focus {
      background: ${props => !props.disabled && props.theme.palette.BLUE_100};
      color: ${props => !props.disabled && props.theme.palette.BW_100};
      text-decoration: none;
      outline: ${props => props.theme.constants.borderWidth.sm}px solid ${props => props.theme.palette.UI_FOCUS_TAB};
    }

    &:hover {
      color: ${props => !props.disabled && props.theme.palette.BW_100};
      background: ${props => !props.disabled && props.theme.palette.BLUE_100};
      border-color: ${props => !props.disabled && 'transparent'};
      cursor: ${props => !props.disabled && 'pointer'};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.sm - 1}px) {
    background-position: center;
    transition: background 0.8s;

    :active {
      background-color: ${props => props.theme.palette.BW_95};
      background-size: 100%;
      transition: background 0s;
    }
  }
`;
exports.ButtonLink = (0, styled_components_1.default)(Link_1.Link) `
  color: inherit;
  text-decoration: inherit;
  &:hover {
    color: inherit;
    background: inherit;
    border-color: inherit;
    cursor: inherit;
  }
  &:focus {
    color: inherit;
    background: inherit;
    text-decoration: inherit;
  }
`;
exports.SmallButton = (0, styled_components_1.default)(exports.StyledButton) `
  font-weight: ${props => props.theme.typography.weight.regular};
  font-size: ${props => props.theme.typography.size.s2}px;
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  color: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_100 : props.theme.palette.TYPE_LIGHT_BLACK)};
  stroke: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_100 : props.theme.palette.TYPE_LIGHT_BLACK)};
  background: ${props => props.theme.palette.BW_100};
  border: ${props => props.disabled
    ? `${props.theme.constants.borderWidth.xs}px solid ${props.theme.palette.UI_DISABLED_BORDER}`
    : `${props.theme.constants.borderWidth.xs}px solid ${props.theme.palette.UI_BORDER_DARK}`};

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    &:focus {
      background: ${props => !props.disabled && props.theme.palette.BW_100};
      border-color: ${props => !props.disabled && props.theme.palette.UI_BORDER_DARK};
      color: ${props => !props.disabled && props.theme.palette.TYPE_LIGHT_BLACK};
      stroke: ${props => !props.disabled && props.theme.palette.TYPE_LIGHT_BLACK};
    }

    &:focus::before {
      padding: ${props => props.theme.spacing.s0}px;
    }

    &:hover {
      color: ${props => !props.disabled && props.theme.palette.BW_100};
      stroke: ${props => !props.disabled && props.theme.palette.BW_100};
      background: ${props => !props.disabled && props.theme.palette.BLUE_100};
      border-color: ${props => !props.disabled && props.theme.palette.BLUE_100};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.sm - 1}px) {
    background-position: center;
    transition: background 0.8s;

    :active {
      background-color: ${props => props.theme.palette.BW_95};
      background-size: 100%;
      transition: background 0s;
    }
  }
`;
exports.LinkAsButton = (0, styled_components_1.default)(exports.StyledButton) `
  cursor: pointer;
  color: ${props => props.disabled
    ? props.theme.palette.UI_DISABLED_BACKGROUND
    : props.overImage
        ? props.theme.palette.BW_100
        : props.theme.palette.BLUE_100};
  stroke: ${props => props.disabled
    ? props.theme.palette.UI_DISABLED_BACKGROUND
    : props.overImage
        ? props.theme.palette.BW_100
        : props.theme.palette.BLUE_100};
  line-height: ${props => props.theme.typography.lineHeight.m3}px;
  transition: ${props => props.theme.animations.primary};
  transition-property: color, text-decoration;
  background: transparent;
  padding: 0;
  margin: 0;
  text-align: left;
  outline-offset: ${props => props.theme.spacing.xs}px;
  text-decoration: none;
  padding: ${props => props.theme.spacing.xs}px;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    &:focus {
      border-radius: 0;
      color: ${props => props.disabled
    ? props.theme.palette.UI_DISABLED_BACKGROUND
    : props.overImage
        ? props.theme.palette.BW_100
        : props.theme.palette.BLUE_100};
      background: transparent;
      text-decoration: none;
      outline: ${props => props.theme.constants.borderWidth.sm}px solid ${props => props.theme.palette.UI_FOCUS_TAB};
    }

    &:hover {
      color: ${props => !props.disabled && props.theme.palette.ORANGE_100};
      stroke: ${props => !props.disabled && props.theme.palette.ORANGE_100};
      background: transparent;
      border-color: ${props => !props.disabled && props.theme.palette.ORANGE_100};
      text-decoration: ${props => !props.disabled && 'underline'};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.sm - 1}px) {
    background-position: center;
    transition: background 0.8s;

    :active {
      background-color: ${props => props.theme.palette.BW_95};
      background-size: 100%;
      transition: background 0s;
    }
  }
`;
exports.IconButton = (0, styled_components_1.default)(exports.StyledButton) `
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  background: ${props => props.theme.palette.BLUE_GRAY_100};

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    &:focus {
      background: ${props => !props.disabled && props.theme.palette.BLUE_GRAY_100};
    }
    &:hover {
      background: ${props => !props.disabled && props.theme.palette.BLUE_GRAY_80};
    }
  }
`;
exports.SubmitButton = (0, styled_components_1.default)(exports.StyledButton) ``;
exports.ChevronRight = (0, styled_components_1.default)(svg_components_1.ChevronRightIcon) `
  padding-left: ${props => props.theme.spacing.s2}px;
  flex-shrink: 0;
  stroke: inherit;
`;
exports.ArrowLeft = (0, styled_components_1.default)(svg_components_1.ArrowLeftIcon) `
  transition: ${props => props.theme.animations.primary};
  stroke: inherit;
`;
exports.BigArrowLeft = (0, styled_components_1.default)(svg_components_1.ArrowLeftIcon) `
  transition: ${props => props.theme.animations.primary};
  stroke: inherit;
`;
exports.ButtonContainer = styled_components_1.default.div `
  margin-left: ${props => props.theme.spacing.s3}px;
  flex-shrink: 0;
  display: inline;
`;
exports.ChevronButtonContainer = styled_components_1.default.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.constants.roundButtonSize.md}px;
  height: ${props => props.theme.constants.roundButtonSize.md}px;
  border-radius: ${props => props.theme.attributes.borderRadius.xxl}px;
  border: none;
  background-color: ${props => props.disabled ? props.theme.palette.LIGHT_GRAY_10 : props.theme.palette.LIGHT_GRAY_20};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;
exports.ChevronButton = (0, styled_components_1.default)(svg_components_1.ChevronMediumIcon) `
  ${props => props.direction === Types_1.ButtonDirection.RIGHT
    ? `
    margin-left: ${props.theme.spacing.xs}px;
    transform: rotate(180deg);
  `
    : `
    margin-right: ${props.theme.spacing.xs}px;
  `}

  width: 100%;

  > path {
    stroke: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_20 : props.theme.palette.LIGHT_BLACK)};
  }
`;
exports.OnlyTextButton = styled_components_1.default.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
exports.SubjectButton = (0, styled_components_1.default)(exports.StyledButton) `
  background: ${props => { var _a; return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.BW_100; }};
  border: ${props => props.theme.spacing.xs}px solid ${props => { var _a; return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.BW_0; }};
  border-radius: ${props => props.theme.spacing.m1}px;
  color: ${props => { var _a; return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.BW_0; }};
  padding: ${props => `${props.theme.spacing.s6}px
    ${props.theme.spacing.s4}px
    ${props.theme.spacing.s6}px
    ${props.theme.spacing.s4}px`};
  font-size: ${props => props.theme.typography.size.s2}px;
  flex: none;

  &:hover {
    color: ${props => !props.disabled && props.theme.palette.BW_100};
    stroke: ${props => !props.disabled && props.theme.palette.BW_100};
    background: ${props => !props.disabled && props.theme.palette.BLUE_100};
    border-color: ${props => !props.disabled && props.theme.palette.BLUE_100};
  }
  &:focus {
    background: ${props => !props.disabled && props.theme.palette.BW_100};
    border-color: ${props => !props.disabled && props.theme.palette.UI_BORDER_DARK};
    color: ${props => !props.disabled && props.theme.palette.TYPE_LIGHT_BLACK};
    stroke: ${props => !props.disabled && props.theme.palette.TYPE_LIGHT_BLACK};
  }
`;
exports.default = exports.StyledButton;
